const baseSuccessCallback = (event) => {
  event.preventDefault();
  event.target.dispatchEvent(new CustomEvent('imperial.form.valid'));
};

const baseErrorCallback = (event) => {
  event.preventDefault();
  event.target.dispatchEvent(new CustomEvent('imperial.form.not-valid'));
};

export const callbacks = {
  base: {
    resetTimeout: 500,
    successCallback: baseSuccessCallback,
    errorCallback: baseErrorCallback
  }
};
